import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        textAlign: "center",
        color: "#ffca55",
        background: "#3b184f",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "5px 15px",
        letterSpacing: "1px",
        zIndex: 0,
        lineHeight: "1em",
        bottom: 0,
        minWidth: "370px",
        fontSize: "0.7rem"
      }}
    >
      <Box>
        <Typography sx={{ fontSize: "0.7rem" }}>
          Probrain Soluções Neurotecnológicas para Saúde e Educação Ltda | CNPJ
          32.841.596/0001-49"
        </Typography>
      </Box>
      <Box>
        <Typography sx={{ fontSize: "0.7rem" }}>
          AV General Carneiro Nº 765 Sala 03, Bairro : Vila Lucy, Sorocaba - SP,
          18.043-003 | atendimento@probrain.com.br
        </Typography>
      </Box>
      <Box>
        <Typography sx={{ fontSize: "0.7rem" }}>
          {t("footer.copyright")} &#169; {new Date().getFullYear()} ProBrain -{" "}
          {t("footer.all_rights_reserved")}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
